import  { useState } from "react";
import axiosService from "../../../utils/axios.service";
import "../scss/report.scss"
import { Table, Button } from 'antd';
import 'antd/dist/antd.min.css'
import Loading from "../../customer/Loading";
import _ from "lodash";

const ReportBHVVOverview = (props) => {    
    const [showLoading, setShowLoading] = useState(false)
    const [pageSize, setPageSize] = useState(10)
    const [locationsWidth, setLocationsWidth] = useState(window.innerWidth)

 
    function convertCurrency(data) {
        let res = new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(data)
        return res;
    };
    var wdt = 200
    if (locationsWidth < 765 ) {
        wdt = 130
    }

    const columns = [
        { dataIndex: 'store_name', title: 'Cơ sở', width: 200  , fixed:'left'},
        {
            dataIndex: 'totalCusHasBHVV',
            title: 'Khách tới cơ sở',
            align: "center",
            render: (data) => {
                return (
                    <p className="text4">{data}</p>
                )
            },
            sorter: (a, b) => a.totalCusHasBHVV - b.totalCusHasBHVV,
        },
        {
            dataIndex: 'totalServiceBHVV',
            title: 'Dịch vụ đã phục vụ',
            align: "center",
            render: (data) => {
                return (
                    <p className="text1">{data}</p>
                )
            },
            sorter: (a, b) => a.totalServiceBHVV - b.totalServiceBHVV,
        },
        {
            dataIndex: 'totalCusBHVVBuy',
            title: 'Số khách mua hàng',
            align: "center",
            render: (data) => {
                return (
                    <p className="text7">{data}</p>
                )
            },
            sorter: (a, b) => a.totalCusBHVVBuy - b.totalCusBHVVBuy,
        },
        {
            dataIndex: 'totalServiceBuy',
            title: 'Số dịch vụ mua',
            align: "center",
            render: (data) => {
                return (
                    <p className="text7">{data}</p>
                )
            },
            sorter: (a, b) => a.totalServiceBuy - b.totalServiceBuy,
        },
        {
            dataIndex: 'revenueCusBHVVBuy',
            title: 'Doanh số thuần',
            align: "center",
            render: (data) => {
                return (
                    <p className="text7">{convertCurrency(data)}</p>
                )
            },
            sorter: (a, b) => a.revenueCusBHVVBuy - b.revenueCusBHVVBuy,
        },
        {
            dataIndex: 'totalActualRevenue',
            title: 'Thực thu',
            align: "center",
            render: (data) => {
                return (
                    <p className="text7">{convertCurrency(data)}</p>
                )
            },
            sorter: (a, b) => a.totalActualRevenue - b.totalActualRevenue,
        }
    ];

    const handleExportData = async () => {
        setShowLoading(true);

        try {
            const header = {
                store_name: "Cơ sở",
                totalCusHasBHVV: "Khách tới cơ sở",
                totalServiceBHVV: "Dịch vụ đã phục vụ",
                totalCusBHVVBuy: "Số khách mua hàng",
                totalServiceBuy: "Số dịch vụ mua",
                revenueCusBHVVBuy: "Doanh số thuần",
                totalActualRevenue: "Thực thu"
            };

            const listExport = [
                _.values(header),
                ..._.map(
                    props.table,
                    item => _.values(_.pick(item, _.keys(header)))
                )
            ];

            const payload = {
                name: "theo_doi_khach_bhvv_",
                sheets: [
                    {
                        name: "Theo dõi khách BHVV",
                        data: listExport
                    }
                ]
            };

            const res = await axiosService("api/mysql/export/have-data", "POST", payload);

            if (res.data.code === 200 && res.data.data?.url) {
                window.open(res.data.data.url, "_blank");
            }
        } catch (error) {
            console.log(error);
        } finally {
            setShowLoading(false);
        }
    };

    const  handleChange = (e) => {
        setPageSize(e.pageSize)
    }
  
    return (
        <>
            <div style={{ backgroundColor: "white" }}>
                
                <div className="border-bottom w-100 pb-2">
                    <div className="d-flex justify-content-between">
                        Bảng số liệu tổng quan
                        <Button size="middle" type="primary" onClick={handleExportData}>
                            <i className="fa-solid fa-file-excel mr-2"></i>Xuất Excel
                        </Button>
                    </div>
                </div>
                    
                <Table 
                    columns={columns} 
                    dataSource={props.table}
                    pagination={{ pageSize: pageSize, showSizeChanger: true, pageSizeOptions: ['10', '15', '30', '50', '100'] }}
                    // scroll={{ x: 'calc(700px + 50%)', y: 600 }}
                    scroll={{ x: columns.length*150, y: 600 }}
                    rowKey="store_name"
                    onChange={handleChange}
                    bordered
                />
            </div>
            <Loading show={showLoading}></Loading>
        </>
    )
}
export default ReportBHVVOverview